<template>
  <v-card class="card-shadow border-radius-xl">
    <v-card-text class="px-0 py-0">
      <v-simple-table class="table border-radius-xl">
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="
                  text-left text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                Name
              </th>
              <th
                class="
                  text-left text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                ID Number
              </th>
              <th
                class="
                  text-left text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                Weeks Worked
              </th>
              <th
                class="
                  text-center text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                Class Grade
              </th>
              <th
                class="
                  text-center text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                Month
              </th>
              <th
                class="
                  text-center text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                General Fund
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in users" :key="item.id">
              <td :class="{ 'border-bottom': i != users.length - 1 }">
                <v-list class="py-0">
                  <v-list-item class="px-0 py-1">
                    <v-list-item-avatar rounded :size="36" class="my-0 me-5">
                      <v-img
                        :alt="item.avatar"
                        :src="item.avatar"
                        class="border-radius-lg"
                      ></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        class="mb-0 text-sm text-typo font-weight-bold"
                        >{{ item.name }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </td>
              <td
                class="text-sm text-secondary mb-0"
                :class="{ 'border-bottom': i != users.length - 1 }"
              >
                {{ item.function }}
              </td>
              <td
                class="text-h5"
                :class="{ 'border-bottom': i != users.length - 1 }"
              >
                <div class="d-flex align-center">
                  <span
                      v-if="false"
                    :class="`text-${item.reviewColor}`"
                    class="me-2 text-sm mt-n1"
                    >●</span
                  >
                  <span class="text-dark text-xs">{{ item.review }}</span>
                </div>
              </td>
              <td
                :class="{ 'border-bottom': i != users.length - 1 }"
                class="text-center"
              >
                <p class="text-secondary mb-0 text-sm">{{ item.email }}</p>
              </td>
              <td
                :class="{ 'border-bottom': i != users.length - 1 }"
                class="text-center"
              >
                <span class="text-secondary text-sm">{{ item.employed }}</span>
              </td>
              <td
                :class="{ 'border-bottom': i != users.length - 1 }"
                class="text-center"
              >
                <span class="text-secondary text-sm">{{ item.id }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "light-table-transparent",
  data() {
    return {
      users: [
        {
          id: "$ 100",
          name: "John Michael",
          avatar: require("@/assets/img/team-2.jpg"),
          function: "65-676487J87",
          review: "4 Weeks",
          reviewColor: "info",
          email: "1",
          employed: "JAN 2023",
        },
        {
          id: "$ 100",
          name: "Alexa Liras",
          avatar: require("@/assets/img/team-3.jpg"),
          function: "89-876487G47",
          review: "4 Weeks",
          reviewColor: "info",
          email: "1",
          employed: "JAN 2023",
        },
        {
          id: "$ 100",
          name: "Laurent Perrier",
          avatar: require("@/assets/img/team-4.jpg"),
          function: "45-766487K89",
          review: "4 Weeks",
          reviewColor: "default",
          email: "1",
          employed: "JAN 2023",
        },
        {
          id: "$ 100",
          name: "Michael Levi",
          avatar: require("@/assets/img/team-4.jpg"),
          function: "98-766487U76",
          review: "4 Weeks",
          reviewColor: "info",
          email: "1",
          employed: "JAN 2023",
        },
        {
          id: "$ 100",
          name: "Richard Gran",
          avatar: require("@/assets/img/team-2.jpg"),
          function: "67-706487K89",
          review: "4 Weeks",
          reviewColor: "danger",
          email: "1",
          employed: "JAN 2023",
        },
        {
          id: "$ 100",
          name: "Miriam Eric",
          avatar: require("@/assets/img/team-4.jpg"),
          function: "71-186487K78",
          review: "4 Weeks",
          reviewColor: "info",
          email: "1",
          employed: "JAN 2023",
        },
      ],
    };
  },
};
</script>
